import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted } from 'vue';
import Header from './components/Header.vue';
import VideoPopup from './components/VideoPopup.vue';
import { store } from '@/store/store'
import CustomCursor from './components/CustomCursor.vue';
import Loader from './components/Loader.vue';
import { useRoute } from 'vue-router';
import axios from 'axios';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const Store = store();
const route = useRoute();

const setDefaultLang = (): void => {
  if (localStorage.getItem('lang')) return;
  let currentLang;
  axios.get('https://api.country.is/')
    .then(response => {
      // Handle successful response
      if (response.data.country === 'GE') {
        currentLang = Store.getLangCodes[0];
      } else {
        currentLang = Store.getLangCodes[1];
      }
      Store.changeCurrentLang(currentLang);
    })
    .catch(error => {
      // Handle error
      console.error('Error fetching data: ' + error.message);
      currentLang = Store.getLangCodes[0];
      Store.changeCurrentLang(currentLang);
    });
}

window.addEventListener('scroll', () => {
  const isScroll: boolean = window.scrollY <= 40;
  Store.changeIsScroll(isScroll)
  Store.setScrollY(window.scrollY);
})

onMounted(() => {
  setDefaultLang();
})

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Loader),
    _createVNode(Header),
    _createVNode(CustomCursor),
    _createVNode(_component_router_view),
    _createVNode(VideoPopup)
  ], 64))
}
}

})